import { OPPORTUNITY_STATUS_META } from '@totem/components/ticketing/opportunityStatus';
import { Filter } from '@totem/types/common';
import { FilterStringValue } from '@totem/types/events';
import { isNotNull } from '@totem/utilities/common';

export const buildFilter = (filters) => {
  const paramFilters: Filter[] = [];

  if (isNotNull(filters['ticket.status'])) {
    paramFilters.push({
      field: 'status',
      values: filters['ticket.status'],
    });
  }
  if (isNotNull(filters['ticket.priority'])) {
    paramFilters.push({
      field: 'priority',
      values: filters['ticket.priority'],
    });
  }
  if (isNotNull(filters['ticket.number'])) {
    paramFilters.push({
      field: 'type',
      values: filters['ticket.number'],
    });
  }
  if (isNotNull(filters['ticket.category'])) {
    paramFilters.push({
      field: 'category',
      values: filters['ticket.category'],
    });
  }
  if (isNotNull(filters['building.name'])) {
    paramFilters.push({
      field: 'buildingId',
      values: filters['building.name'],
    });
  }

  return paramFilters;
};

export const buildAffiliatedFilter = (filters) => {
  const paramFilters: Filter[] = [];

  if (isNotNull(filters['ticket.status'])) {
    paramFilters.push({
      field: 'status',
      values: filters['ticket.status'],
    });
  }
  if (isNotNull(filters['ticket.priority'])) {
    paramFilters.push({
      field: 'priority',
      values: filters['ticket.priority'],
    });
  }
  if (isNotNull(filters['ticket.category'])) {
    paramFilters.push({
      field: 'category',
      values: filters['ticket.category'],
    });
  }
  if (isNotNull(filters['ticket.number'])) {
    paramFilters.push({
      field: 'type',
      values: filters['ticket.number'],
    });
  }
  if (isNotNull(filters['building.name'])) {
    paramFilters.push({
      field: 'buildingId',
      values: filters['building.name'],
    });
  }
  if (isNotNull(filters['organization.name'])) {
    paramFilters.push({
      field: 'organizationId',
      values: filters['organization.name'],
    });
  }

  return paramFilters;
};

export const getTicketColor = (ticketType: string) => {
  switch (ticketType) {
    case 'Incident':
      return '#F07800';
    case 'Service Request':
      return '#F0A400';
    case 'Change Request':
      return '#F0CB00';
    case 'Problem':
      return '#D90000';
    case 'Site Project':
      return '#378FEF';
    default:
      return '#606060';
  }
};

export const getTicketAbbr = (ticketType: string) => {
  switch (ticketType) {
    case 'Incident':
      return 'Incident';
    case 'Service Request':
      return 'Service';
    case 'Change Request':
      return 'Change';
    case 'Problem':
      return 'Problem';
    case 'Site Project':
      return 'Project';
    default:
      return ticketType;
  }
};

export const getTicketTypeFilter = () => {
  return [
    {
      text: 'Incident',
      value: 'Incident',
    },
    {
      text: 'Problem',
      value: 'Problem',
    },
    {
      text: 'Change Request',
      value: 'Change Request',
    },
    {
      text: 'Service Request',
      value: 'Service Request',
    },
    {
      text: 'Project',
      value: 'Project',
    },
    {
      text: 'Site Project',
      value: 'Site Project',
    },
  ];
};

export const getPriorityFilter = () => {
  return [
    {
      text: 'P1',
      value: 'P1',
    },
    {
      text: 'P2',
      value: 'P2',
    },
    {
      text: 'P3',
      value: 'P3',
    },
    {
      text: 'P4',
      value: 'P4',
    },
  ];
};

export const getStatusFilter = () => {
  return [
    {
      text: 'OPEN',
      value: 'OPEN',
    },
    {
      text: 'RESOLVED',
      value: 'RESOLVED',
    },
    {
      text: 'CLOSED',
      value: 'CLOSED',
    },
  ];
};

export const getFilterOptions = (options: FilterStringValue[]) => {
  if (isNotNull(options)) {
    return options
      .map((option) => {
        return {
          text: option.name,
          value: option.value,
        };
      })
      .sort((compA, compB) =>
        compA.text === compB.text ? 0 : compA.text > compB.text ? 1 : -1,
      );
  }
  return [];
};

// Optimize opportunity statuses, as stored in extras.optimize.opportunityStatus. "Savings Booked" is shown as
// "Savings Realized". "Not Set" matches opportunities with no status (the API treats it specially).
export const getOpportunityStatusFilter = () => [
  ...Object.keys(OPPORTUNITY_STATUS_META).map((status) => ({
    text: status === 'Savings Booked' ? 'Savings Realized' : status,
    value: status,
  })),
  { text: 'Not Set', value: 'Not Set' },
];
